// hooks/useComplaintsCount.js

import { useState, useEffect } from 'react';
import { subscribeToComplaintsCount, getCachedComplaintsCount } from '../services/complaintsCountService';

export const useComplaintsCount = () => {
    const [counts, setCounts] = useState(() => {

        const cached = getCachedComplaintsCount();
        return cached || {
            total: 0,
            active: 0,
            pending: 0,
            inOperation: 0,
            paused: 0,
            completed: 0,
            urgent: 0,
            delayed: 0,
            lastUpdated: null
        };
    });

    useEffect(() => {
        const unsubscribe = subscribeToComplaintsCount((updatedCounts) => {
            setCounts(updatedCounts);
        });

        return () => {
            unsubscribe();
        };
    }, []);

    return counts;
};

// Specific hooks for different count types
export const useActiveComplaintsCount = () => {
    const counts = useComplaintsCount();
    return counts.inOperation || 0;
};

export const useTotalComplaintsCount = () => {
    const counts = useComplaintsCount();
    return counts.total || 0;
};

export const useDelayedComplaintsCount = () => {
    const counts = useComplaintsCount();
    return counts.delayed || 0;
};

export const useUrgentComplaintsCount = () => {
    const counts = useComplaintsCount();
    return counts.urgent || 0;
};